/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import { $axios, $axiosRefresh } from "./axiosInstance";
import {
	handleErrorWithRedirect,
	handleAuthenticationRedirect,
	getCurrentUrlWithoutContextPath,
} from "./handler/errorHandler";
import { getCSRFToken } from "./handler/csrfHandler";
import { handleCancellableRequest, handleCancellableResponse } from "./handler/requestCancelHandler";

declare module "axios" {
	interface AxiosRequestConfig {
		handleErrorWithRedirect?: boolean;
	}
}

const setHeaders = (request: InternalAxiosRequestConfig): void => {
	request.headers.set("X-Requested-With", "XMLHttpRequest");
	request.headers.set("getUrl", getCurrentUrlWithoutContextPath());
	request.headers.set("CSRFToken", getCSRFToken());
};

const isCancel = axios.isCancel;

$axios.interceptors.request.use((request: InternalAxiosRequestConfig): any => {
	setHeaders(request);
	handleCancellableRequest(request as AxiosRequestConfig);
	return request;
});

$axios.interceptors.response.use(
	(response) => {
		handleCancellableResponse(response.config?.cancelToken);
		return response;
	},
	(error: unknown) => {
		if (axios.isCancel(error)) {
			return Promise.reject(error);
		}
		if (!axios.isAxiosError(error)) {
			return Promise.reject(error);
		}
		handleCancellableResponse(error.config?.cancelToken);
		handleAuthenticationRedirect(error);
		handleErrorWithRedirect(error);
		return Promise.reject(error);
	}
);

// handle createAuthRefreshInterceptor refresh response with unauthorized
$axiosRefresh.interceptors.response.use(
	(response) => response,
	(error) => {
		handleAuthenticationRedirect(error);
		return Promise.reject(error);
	}
);

export { $axios, isCancel };
